var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('unicon',{staticClass:"icon--1 w-6 h-6",attrs:{"name":_vm.name,"fill":"#f2f2f0"}})}
var staticRenderFns = []

export { render, staticRenderFns }